import BDPSeriesFAQs from './BDPSeriesFAQs.jsx';

export default function FAQContent() {

	return [
			{id: 0, title: 'BDP Series FAQ', content: BDPSeriesFAQs()}
	];
}